import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { resetPolicyMenu } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function resetPolciyMenu({
  accountId,
  procedureId,
}: TVariables): Promise<TResult> {
  const response = await fetch(resetPolicyMenu(accountId, procedureId), {
    method: 'PUT',
    headers: {
      Authorization: getTokenWithType(),
      'Content-Type': 'application/json',
    },
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: string;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  procedureId: number | undefined;
  accountId: number | undefined;
};

type TSnapshot = unknown;

function useResetPolicyMenu(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { accountId, procedureId } = params;
    const result = await resetPolciyMenu(params);
    if (result.Data) {
      queryClient.invalidateQueries(['get_procedure', accountId, procedureId], {
        refetchInactive: true,
      });
    } else if (result.Errors) throw result;

    return result;
  });
}

export { useResetPolicyMenu };
